import TMT from './imgs/500Dtmtbar.png';

const SteelData = [
    {
        id: "1",
        imgsrc: TMT,
        title: "500D TMT Bar",
        qty: "1kg",
        cost: "₹10.00"
    },
    {
        id: "2",
        imgsrc: TMT,
        title: "500D TMT Bar",
        qty: "1kg",
        cost: "₹10.00"
    },
    {
        id: "3",
        imgsrc: TMT,
        title: "500D TMT Bar",
        qty: "1kg",
        cost: "₹10.00"
    },
    {
        id: "4",
        imgsrc: TMT,
        title: "500D TMT Bar",
        qty: "1kg",
        cost: "₹10.00"
    },
    {
        id: "5",
        imgsrc: TMT,
        title: "500D TMT Bar",
        qty: "1kg",
        cost: "₹10.00"
    },
    {
        id: "6",
        imgsrc: TMT,
        title: "500D TMT Bar",
        qty: "1kg",
        cost: "₹10.00"
    },
    {
        id: "7",
        imgsrc: TMT,
        title: "500D TMT Bar",
        qty: "1kg",
        cost: "₹10.00"
    },
    {
        id: "8",
        imgsrc: TMT,
        title: "500D TMT Bar",
        qty: "1kg",
        cost: "₹10.00"
    },
    {
        id: "9",
        imgsrc: TMT,
        title: "500D TMT Bar",
        qty: "1kg",
        cost: "₹10.00"
    },
    {
        id: "10",
        imgsrc: TMT,
        title: "500D TMT Bar",
        qty: "1kg",
        cost: "₹10.00"
    },
];
export default SteelData;